import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const TabletIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M14.5 2.36526C14.7761 2.36526 15 2.58912 15 2.86526V13.8653C15 14.1414 14.7761 14.3653 14.5 14.3653H1.5C1.22386 14.3653 1 14.1414 1 13.8653V2.86526C1 2.58912 1.22386 2.36526 1.5 2.36526H14.5ZM12 3.86526H2.5V12.8653H12V3.86526ZM13.25 7.61526C12.8358 7.61526 12.5 7.95105 12.5 8.36526C12.5 8.77947 12.8358 9.11526 13.25 9.11526C13.6642 9.11526 14 8.77947 14 8.36526C14 7.95105 13.6642 7.61526 13.25 7.61526Z"
		/>
	</svg>
))
